export default "__VITE_ASSET__CHYhExsv__"